var map = {
	"./logo-1.svg": 1209,
	"./logo-2.svg": 1210,
	"./logo-3.svg": 1211,
	"./logo-4.svg": 1212,
	"./logo-5.svg": 1213,
	"./logo-6.svg": 1214,
	"./logo-7.svg": 1215,
	"./logo-8.svg": 1216
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1208;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img ^\.\/logo\-.*\.svg$
// module id = 1208
// module chunks = 173